<template>
  <div>
    <v-card class="standby_lnfo">
      <v-card-text>
        <p>
          {{ outOfServiceTxt }}
        </p>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import store from "../store";
import Export from "../export";
import router from "../vue-router/index";
export default {
  name: "OutOfService",
  data() {
    return {
      outOfServiceTxt: "Out of Service",
      outOfServiceData: null,
      getOperationTimerId: null,
    };
  },
  async mounted() {
    var getOutOfService = await Export.getOutOfService();
    this.outOfServiceData = getOutOfService.data;
    for (var i = 0; i < this.outOfServiceData.length; i++) {
      if (this.outOfServiceData[i].checked == "true") {
        this.outOfServiceTxt = this.outOfServiceData[i].text;
      }
    }
    this.getOperationTimerId = setInterval(this.getOperation, 30000);
    /*var txt =
      "Out of service page started with bus stop id " +
      this.currentBusStopId +
      ".";
    await Export.postMail(txt, store.state.mail);*/
  },
  methods: {
    async getOperation() {
      var getOperation = await Export.getOperation();
      this.operationCommand = getOperation.data[0];
    },
  },
  computed: {
    operationCommand: {
      get() {
        return store.state.operationCommand;
      },
      set(value) {
        store.state.operationCommand = value;
      },
    },
    outOfService: {
      get() {
        return store.state.outOfService;
      },
      set(value) {
        store.state.outOfService = value;
      },
    },
    currentBusStopId: {
      get() {
        return store.state.currentBusStopId;
      },
      set(value) {
        store.state.currentBusStopId = value;
      },
    },
  },
  watch: {
    operationCommand() {
      if (this.operationCommand.outOfService == "false") {
        this.outOfService = false;
        clearInterval(this.getOperationTimerId);
        router.push("/client");
      }
    },
  },
};
</script>
<style>
.standby_lnfo {
  text-align: center;
  margin-top: 20vh;
}
.standby_lnfo p {
  font-size: 3rem;
  line-height: 4rem;
  padding: 10vh 0;
}
</style>
